/**
 * Российский мобильный/городской номер: +7 и до 10 национальных цифр.
 * Ввод/вставка: 8… → 7…, 9XXXXXXXXX (10 цифр) → 7XXXXXXXXXX.
 */

export function extractRuPhoneDigits(input: string): string {
  let d = input.replace(/\D/g, '');
  if (!d.length) return '';
  if (d.startsWith('8')) d = '7' + d.slice(1);
  if (d.length === 10 && d.startsWith('9')) d = '7' + d;
  if (d.startsWith('7')) return d.slice(0, 11);
  if (d.startsWith('9')) return ('7' + d).slice(0, 11);
  return d.slice(0, 11);
}

export function formatRuPhoneDisplay(digits: string): string {
  const d = extractRuPhoneDigits(digits);
  if (!d.length) return '';
  if (!d.startsWith('7')) {
    return d.length ? `+${d}` : '';
  }
  const rest = d.slice(1);
  if (rest.length === 0) return '+7';
  let s = '+7 (';
  const code = rest.slice(0, 3);
  s += code;
  if (rest.length <= 3) {
    return rest.length === 3 ? `${s})` : s;
  }
  s += ') ';
  s += rest.slice(3, 6);
  if (rest.length <= 6) return s;
  s += `-${rest.slice(6, 8)}`;
  if (rest.length <= 8) return s;
  return `${s}-${rest.slice(8, 10)}`;
}

export function countDigitsBefore(str: string, index: number): number {
  let n = 0;
  const end = Math.min(index, str.length);
  for (let i = 0; i < end; i++) {
    if (/\d/.test(str[i])) n++;
  }
  return n;
}

/**
 * Сколько цифр должно быть слева от курсора в отформатированной строке после правки.
 * Если курсор в конце поля — вся длина нормализованных цифр (иначе при «9»→«79» каретка
 * оказывается после первой цифры маски, а не после введённой цифры).
 */
export function caretDigitTargetAfterEdit(
  rawValue: string,
  selectionStart: number | null,
  normalizedDigits: string
): number {
  const start = selectionStart ?? 0;
  const len = rawValue.length;
  if (start >= len) {
    return normalizedDigits.length;
  }
  return countDigitsBefore(rawValue, start);
}

export function caretIndexAfterDigitCount(formatted: string, digitCount: number): number {
  if (digitCount <= 0) return 0;
  let seen = 0;
  for (let i = 0; i < formatted.length; i++) {
    if (/\d/.test(formatted[i])) {
      seen++;
      if (seen === digitCount) return i + 1;
    }
  }
  return formatted.length;
}

/** Полный RU E.164 (+7XXXXXXXXXXX) или undefined, если номер не из 11 цифр. */
export function ruPhoneToE164(displayOrDigits: string): string | undefined {
  const d = extractRuPhoneDigits(displayOrDigits);
  if (d.length === 11) return `+${d}`;
  return undefined;
}
